export var DEPLOY_DATE = new Date('2026-08-19T11:26:14+0000');
